import { Controller } from "@hotwired/stimulus";
import BottomSheet from "@/helpers/mobile/bottom_sheet.jsx";

// Connects to data-controller="shared--dropdown-sheet"
//
// In the mobile app, a Bootstrap dropdown (a `.dropdown-toggle` + `.dropdown-menu`
// inside this element) opens its items in a bottom sheet instead of the dropdown
// menu — mirroring the React DropDown.Wrapper behavior on SPA pages. No-op on web.
export default class extends Controller {
  connect() {
    if (!window.isApp) return;

    this.toggle = this.element.querySelector(".dropdown-toggle");
    const menu = this.element.querySelector(".dropdown-menu");
    if (!this.toggle || !menu) return;

    this.sheet = new BottomSheet();
    this.buildList(menu);

    // Take over from Bootstrap's dropdown handling. The original menu is left
    // intact in the DOM (just hidden) so a Turbo cache-restore still finds it
    // and reconnect() works after back/forward navigation.
    this.toggle.removeAttribute("data-bs-toggle");
    this.onToggle = (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.sheet.open(this.list);
    };
    this.toggle.addEventListener("click", this.onToggle);
  }

  disconnect() {
    this.sheet?.remove();
    if (this.onToggle) this.toggle?.removeEventListener("click", this.onToggle);
    // Restore the markup we changed so the cached page snapshot is pristine.
    this.toggle?.setAttribute("data-bs-toggle", "dropdown");
  }

  buildList(menu) {
    this.list = document.createElement("ul");
    this.list.className = "divide-y divide-neutral/25";

    menu.querySelectorAll(":scope > li").forEach((li) => {
      // Separators are handled by divide-y.
      if (li.classList.contains("divider")) return;
      const link = li.querySelector("a");
      // Server-rendered menus keep both states of a toggle (e.g. subscribe /
      // unsubscribe) and hide the inactive one inline — skip those.
      if (!link || link.style.display === "none") return;

      // Clone instead of moving the live nodes so the original menu stays intact
      // for Turbo snapshots.
      const item = li.cloneNode(true);
      // `.dropdown-item` is a flex row in the app; `gap-2` spaces the icon from
      // the text (the server-rendered items lack the React items' gap span).
      item.querySelector("a")?.classList.add("dropdown-item", "gap-2");
      // Close the sheet once an item is chosen (the link still navigates).
      item.addEventListener("click", () => this.sheet.close());
      this.list.append(item);
    });
  }
}
